module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/main-view_bb70468e8b52248ac1551e854f298b45.png";